import { Dispatch, SetStateAction } from 'react';
import { useCssHandles } from '../../../../utils/functions';

type FilterNavigatorV3FilterButtonProps = {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const CSS_HANDLES = [
	'filters',
	'filtersWrapperMobile',
	'filterPopupButton',
	'filterPopupTitle',
	'filterPopupArrowIcon',
	'filterIcon',
];
const FilterButton = ({ isOpen, setIsOpen }: FilterNavigatorV3FilterButtonProps) => {
	const { handles, withModifiers }: any = useCssHandles(`vtex-search-result-3-x-`, CSS_HANDLES);
	const filtersLayoutClasses = withModifiers('filters', 'layout');

	return (
		<div className={`${filtersLayoutClasses}`}>
			<div className={`${handles.filters}`}>
				<div className={`${handles.filtersWrapperMobile} flex items-center justify-center flex-auto h-100`}>
					<button
						className={`${handles.filterPopupButton}  ph3 pv5 mv0 mv0 pointer flex justify-center items-center bn`}
						onClick={() => {
							setIsOpen(!isOpen);
						}}
					>
						<span className={`${handles.filterPopupTitle} c-on-base t-action--small ml-auto`}>Filtrar</span>
						<span className={`${handles.filterPopupArrowIcon} ml-auto pl3 pt2`}>
							<svg
								fill="none"
								width="16"
								height="16"
								viewBox="0 0 24 24"
								className={`${handles.filterIcon}`}
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
							>
								<use href="#mpa-filter-settings" xlinkHref="#mpa-filter-settings"></use>
							</svg>
						</span>
					</button>
				</div>
			</div>
		</div>
	);
};
export default FilterButton;
